import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { Map } from 'immutable';
import { isEqual } from 'underscore';

import Textarea from '../../../helpers/Textarea';
import FormGroup from '../../../helpers/FormGroup';

import { getIn, getOriginalIn } from '../../../../utils/ChangeSpy';
import ContactExecutiveIndustries from '../ContactExecutiveIndustries';
import ContactExecutiveHarvcoTags from '../ContactExecutiveHarvcoTags';

import style from './style.module.css';

/**
 * Component is used to display contact executive details (industries, tags, bio...).
 *
 * @param props {Object} Any extra props that allowed on <p> tag.
 * @param props.contact {Immutable.Map} Map with contact data.
 * @param props.onChange {Function} OnChange callback. 1st arg is event.
 * @returns {XML}
 * @private
 * @class
 */
const ContactExecutiveDetailsPanel = props => {
  const {
    contact,
    onChange,
    suggestions,
    suggestIndustry,
    addIndustry,
    deleteIndustry,
    addTag,
    deleteTag,
    onClickIndustries,
    onClickTags,
  } = props;

  const changed =
    !isEqual(getIn(contact, 'selectedBICs', []), getOriginalIn(contact, 'selectedBICs', [])) ||
    !isEqual(getIn(contact, 'selectedBMs', []), getOriginalIn(contact, 'selectedBMs', []));

  return (
    <div className={classNames(style.host, 'panel panel-default')}>
      <div className="panel-heading" data-parent="#accordion" data-target="#acc-slide-2" data-toggle="collapse">
        <h4 className="panel-title"> Exec Details </h4>
      </div>

      <div className="panel-collapse collapse in" id="acc-slide-2">
        <div className={classNames(style.detailsBody, 'panel-body')}>
          <div className="highlight pt0">
            <FormGroup>
              <Textarea
                label="Personal Bio"
                name="legacyPersonalBio"
                onChange={onChange}
                placeholder="Personal Bio"
                rows="5"
                value={contact.get('legacyPersonalBio')}
                showLabel
              />
            </FormGroup>

            <FormGroup>
              <Textarea
                label="Track Record"
                name="trackRecord"
                onChange={onChange}
                placeholder="Track Record"
                rows="5"
                value={contact.get('trackRecord')}
                showLabel
              />
            </FormGroup>

            <FormGroup>
              <Textarea
                label="Research Notes"
                name="researchNotes"
                onChange={onChange}
                placeholder="Research Notes"
                rows="2"
                value={contact.get('researchNotes')}
                showLabel
              />
            </FormGroup>
          </div>

          <div className={style.tablesPanel}>
            <ContactExecutiveIndustries
              changed={changed}
              industries={contact.get('industryTags')}
              onAdd={addIndustry}
              onChange={onChange}
              onClick={onClickIndustries}
              onDelete={deleteIndustry}
              suggestIndustry={suggestIndustry}
              suggestions={suggestions}
            />

            <ContactExecutiveHarvcoTags
              onAdd={addTag}
              onChange={onChange}
              onClick={onClickTags}
              onDelete={deleteTag}
              tags={contact.get('harvcoTags')}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

ContactExecutiveDetailsPanel.propTypes = {
  contact: PropTypes.instanceOf(Map).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ContactExecutiveDetailsPanel;
